import { useState } from 'react'
import { motion } from 'motion/react'
import { PixelIcon } from './PixelIcon'
import type { PixelIconName } from '@/game/pixelIcons'

interface ArtImageProps {
  src: string
  alt: string
  className?: string
  fallbackIcon?: PixelIconName | string
  fallbackColor?: string
  reducedMotion?: boolean
  fit?: 'contain' | 'cover'
}

export function ArtImage({ src, alt, className, fallbackIcon, fallbackColor, reducedMotion, fit = 'contain' }: ArtImageProps) {
  const [loaded, setLoaded] = useState(false)
  const [failed, setFailed] = useState(false)

  if (failed) {
    return (
      <span className={['grid place-items-center', className].filter(Boolean).join(' ')} style={{ color: fallbackColor }}>
        <PixelIcon name={fallbackIcon ?? 'gift'} size={28} title={alt} />
      </span>
    )
  }

  return (
    <span className={['relative block overflow-hidden', className].filter(Boolean).join(' ')}>
      {!loaded && fallbackIcon && (
        <span className="absolute inset-0 grid place-items-center opacity-40" style={{ color: fallbackColor }}>
          <PixelIcon name={fallbackIcon} size={24} />
        </span>
      )}
      <motion.img
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        onLoad={() => setLoaded(true)}
        onError={() => setFailed(true)}
        className={`h-full w-full ${fit === 'cover' ? 'object-cover' : 'object-contain'}`}
        initial={reducedMotion ? { opacity: 0 } : { opacity: 0, scale: 0.92 }}
        animate={loaded ? { opacity: 1, scale: 1 } : { opacity: 0, scale: reducedMotion ? 1 : 0.92 }}
        transition={{ type: 'spring', stiffness: 300, damping: 26 }}
        draggable={false}
      />
    </span>
  )
}
